import { Footer, Header, HeaderB2B } from 'components'
import React, { useEffect, useState } from 'react'

const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

const ComingSoon = () => {
  const desiredDate = '2025-01-06' // Format: YYYY-MM-DD
  
  const [showCountdown, setShowCountdown] = useState(true)

  const calculateTimeLeft = () => {
    const difference = +new Date(desiredDate) - +new Date()
    let timeLeft = {}
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      }
    }
    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    if (isObjectEmpty(timeLeft)) {
      setShowCountdown(false)
    } else {
      setShowCountdown(true)
      const timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft())
      }, 1000)
      return () => clearTimeout(timer)
    }
  })

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time
  }

  return (
    <div>
      <Header />

      <div style={{ padding: '5rem 12.5rem' }}>
        <div style={{ fontFamily: 'Gilroy-ExtraBold', fontSize: '5.5rem' }}>
          We Will <br /> Be Back Soon
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: '3rem' }}>
          <div style={{ display: 'flex', columnGap: '2.5rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '1rem' }}>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.125rem', color: '#71869C' }}>
                Day{formatTime(timeLeft.days) > 1 ? 's' : ''}
              </span>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '3rem' }}>
                {formatTime(timeLeft.days) || '00'}
              </span>
            </div>
            <div className='countdown-timer' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '1rem' }}>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.125rem', color: '#71869C' }}>
                Hour{formatTime(timeLeft.hours) > 1 ? 's' : ''}
              </span>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '3rem' }}>
                {formatTime(timeLeft.hours) || '00'}
              </span>
            </div>
            <div className='countdown-timer' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '1rem' }}>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.125rem', color: '#71869C' }}>
                Minute{formatTime(timeLeft.minutes) > 1 ? 's' : ''}
              </span>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '3rem' }}>
                {formatTime(timeLeft.minutes) || '00'}
              </span>
            </div>
            <div className='countdown-timer' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '1rem' }}>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.125rem', color: '#71869C' }}>
                Second{formatTime(timeLeft.seconds) > 1 ? 's' : ''}
              </span>
              <span style={{ fontFamily: 'Gilroy-Bold', fontSize: '3rem' }}>
                {formatTime(timeLeft.seconds) || '00'}
              </span>
            </div>
          </div>
          <div style={{ fontFamily: 'Gilroy-Medium', fontSize: '1.75rem', color: '#71869C', lineHeight: '3rem' }}>
            We're strong believers that the best solutions come from gathering new insights and pushing conventional boundaries.
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default ComingSoon
